import * as React from 'react';

import { ReactComponent as FileIcon } from 'assets/images/ic-file-large.svg';
import { useComponent } from 'hooks';
import { Button, Container, ContainerItem, Dialog, Header } from 'ui';

interface Props extends Record<string, unknown> {
  isOpen: boolean;
  onClose: () => void;
  orgName: string;
}

export const UnarchiveInvitedAccountModal: React.FC<Props> = useComponent((props) => {
  return (
    <Dialog
      noCancelAction
      height="525px"
      width="459px"
      handleClose={props.onClose}
      isOpen={props.isOpen}
      title={''}
      action={
        <Button
          fullWidth
          label={'Okay, got it!'}
          onClick={props.onClose}
          color="primary"
          variant="contained"
          size="large"
        />
      }
    >
      <Container column padding={0} width="100%" justify="center">
        <ContainerItem padding="0 0 16px 0" width="100%" textAlign="center">
          <FileIcon />
        </ContainerItem>

        <ContainerItem padding="0 0 16px 0" width="100%" textAlign="center">
          <Header content={`Next steps for unarchiving ${props.orgName}`} type="h2" />
        </ContainerItem>

        <ContainerItem padding="0 0 16px 0" width="100%" textAlign="center">
          Since this account was archived while in the onboarding process, they must first finish and submit
          their application before you’re able to approve it. They have received an email that highlights
          their next steps.
        </ContainerItem>

        <ContainerItem padding="0 0 16px 0" width="100%" textAlign="center">
          Once they submit their application, your team will be alerted that there is a new account to review.
          You will then go through the account approval process, which will make it officially active.
        </ContainerItem>
      </Container>
    </Dialog>
  );
});
